
import { mapState, mapMutations } from 'vuex'
const axios = require('axios')

export default {
  data() {
    return {
      countAnimation: false,
      loaded: false,
      isAppCatering: false
    }
  },
  mounted() {
    if (process.client) {
      // Retrieve source cookie to determine if we're coming from app
      const cookies = document.cookie
        .split('; ')
        .reduce((acc, cookie) => {
          const [key, value] = cookie.split('=')
          acc[key] = value
          return acc
        }, {})
      if (cookies.source && cookies.source == 'app' && this.channel && this.channel == 'catering') {
        this.isAppCatering = true
      }
    }
  },
  computed: {
    ...mapState(['user', 'showCart', 'showMobileMenu', 'location', 'order', 'offerScreenContentCards', 'channel', 'globalClass']),
    mobile() {
      return this.$mq == 'sm' || this.$mq == 'md'
    },
    safeChannel() {
      return this.channel || 'default'
    },
    count() {
      if (this.order && this.order.products.length) {
        let count = 0
        this.order.products.forEach(product => {
          count += product.quantity
        })
        return count
      } else {
        return false
      }
    },
    notifications() {
      return this.offerScreenContentCards.filter((card) => card.viewed === false).length
    },
    isConfirmLocationModalButton() {
      if (this.$cookiz.get("location-confirmed") === true) {
        return false
      }

      const routesToExclude = ['order', 'menu', 'order/checkout']
      if (routesToExclude.includes(this.$route.name) || this.$route.path.includes('locations')) {
        return false
      }

      if (!this.location) {
        return false
      }

      return true
    }
  },
  methods: {
    ...mapMutations(['setShouldOpenConfirmLocationModal']),
    handleConfirmLocationModalButton() {
      // TEMPORARY: Modal disabled - redirect directly
      // TO REVERT: Uncomment code below and remove the direct redirect
      /* ORIGINAL CODE:
      if (this.isConfirmLocationModalButton) {
        this.setShouldOpenConfirmLocationModal(true)
      } else {
        this.$router.push('/menu')
      }
      */
      
      // Direct redirect (temporary solution)
      if (this.location) {
        this.$router.push('/order')
      } else {
        this.$router.push('/menu')
      }
    },
    toggleMobileMenu() {
      document.activeElement.blur()
      this.$store.commit('setShowMobileMenu', !this.showMobileMenu)
    },
    toggleCart() {
      this.$store.commit('setShowCart', !this.showCart)
    },
    animateCount() {
      this.countAnimation = true
      setTimeout(() => {
        this.countAnimation = false
      }, 800)
    },
    setPickup() {
      if (this.order && this.order.handoff == 'dispatch') {
        this.$api.setHandoff('pickup')
      } else {
        this.$router.push('/locations?mode=pickup')
      }
    },
    setDelivery() {
      this.$router.push('/locations?mode=delivery')
    }
  },
  watch: {
    'order.products': {
      handler(newProducts, oldProducts) {
        // Animate count if product is added to the order
        if (oldProducts && newProducts) {
          const oldQty = oldProducts.reduce((total, product) => total + product.quantity, 0)
          const newQty = newProducts.reduce((total, product) => total + product.quantity, 0)
          if (newQty > oldQty) {
            this.animateCount()
          }
        }
      },
      deep: true,
    },
  }
}
